import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { setImpersonationUserInfo } from '../utils/authStorage';

export default function ImpersonateBootstrap() {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const hash = window.location.hash ? window.location.hash.slice(1) : '';
      if (!hash) {
        navigate('/signin', { replace: true });
        return;
      }
      const decoded = decodeURIComponent(hash);
      const data = JSON.parse(decoded);
      if (!data?.token) {
        navigate('/signin', { replace: true });
        return;
      }
      setImpersonationUserInfo(data);
      window.history.replaceState(null, '', '/impersonate');
      const userType = (data.userType || '').toString().toLowerCase();
      navigate(userType === 'technician' ? '/jobs' : '/dashboard', { replace: true });
    } catch (e) {
      console.error('Failed to bootstrap impersonation', e);
      navigate('/signin', { replace: true });
    }
  }, [navigate]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
      <CircularProgress />
      <Typography sx={{ color: '#64748b', fontSize: 14 }}>Starting impersonation…</Typography>
    </Box>
  );
}
